import React from 'react';
import Hero from "./components/ccsu-fm/Hero";
import Main from "./components/ccsu-fm/Main";

const CcsuFm = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default CcsuFm;